import React, { useRef, useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import avatarVideo from "../../assets/avatares/mute-violet.webm";
import avatarVideoMp4 from "../../assets/avatares/mute-violet.mp4";
import closeCross from "../../assets/close.svg";
import ScenarioBar from "../../components/ScenarioBar";
import NextButton from "../../components/NextButton";

import img1 from "../../assets/tests/scn3/estratificacion-paciente-1.jpg";
import img2 from "../../assets/tests/scn3/estratificacion-paciente-2.jpg";

import { useVideoWithSound } from "../../hooks/useVideoWithSound";
import "./Scenario3.css";

function MagnifyIcon({ size = 20 }) {
	return (
		<svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
			<circle cx="10.5" cy="10.5" r="6.5" fill="none" stroke="currentColor" strokeWidth="2" />
			<path
				d="M15.2 15.2 21 21"
				fill="none"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
			/>
		</svg>
	);
}

function Scenario3Context1({ intl }) {
	const navigate = useNavigate();
	const location = useLocation();

	const { videoRef } = useVideoWithSound({ 
		autoPlay: true, 
		volume: 0.8
	});

	const [lightbox, setLightbox] = useState(null);

	const activeScenario = getScenarioNumByPath(location.pathname);

	useEffect(() => {
		if (!lightbox) return;
		const onKey = (e) => {
			if (e.key === "Escape") setLightbox(null);
		};
		window.addEventListener("keydown", onKey);
		const prevOverflow = document.body.style.overflow;
		document.body.style.overflow = "hidden";
		return () => {
			window.removeEventListener("keydown", onKey);
			document.body.style.overflow = prevOverflow;
		};
	}, [lightbox]);

	return (
		<div className="h-100">
			<div className="container-fluid position-relative h-100">
				<div className="row h-100 d-flex align-items-center">
					<div className="col-md-4 d-flex flex-column justify-content-end h-100 px-4 pb-4">
						<video
							ref={videoRef}
							className="mb-4 pb-5"
							autoPlay
							playsInline
							preload="auto"
							muted
						>
							<source src={avatarVideoMp4}  type="video/mp4" />
							<source src={avatarVideo} type="video/webm" />
						</video>
					</div>

					{/* Columna derecha: espacio visual */}
					<div className="col-md-8 d-flex flex-column justify-content-top pt-5 align-items-end bg-blur-violet h-100 px-5">
						<div className="row recuadro-white recuadro-border-violet txtTexto1 mb-1 w-100 text-center">
							<div className="col-md-12">
								<h3 className="txtTitulos violet mb-4">
									Estratificación del paciente
								</h3>
							</div>
							<div className="col-md-6 d-flex flex-column align-items-center pb-2">
								<div className="scenario3-intro-thumb">
									<button
										type="button"
										className="scenario3-intro-thumb-btn"
										onClick={() =>
											setLightbox({
												src: img1,
												alt: "Estratificación del paciente - imagen 1",
											})
										}
										aria-label="Ampliar imagen 1"
									>
										<img
											src={img1}
											className="img-fluid w-100"
											alt="Estratificación del paciente - imagen 1"
										/>
									</button>
									<span className="scenario3-intro-zoom-badge" title="Pulsa para ampliar">
										<MagnifyIcon size={18} />
									</span>
								</div>
							</div>
							<div className="col-md-6 d-flex flex-column align-items-center pb-2">
								<div className="scenario3-intro-thumb">
									<button
										type="button"
										className="scenario3-intro-thumb-btn"
										onClick={() =>
											setLightbox({
												src: img2,
												alt: "Estratificación del paciente - imagen 2",
											})
										}
										aria-label="Ampliar imagen 2"
									>
										<img
											src={img2}
											className="img-fluid w-100"
											alt="Estratificación del paciente - imagen 2"
										/>
									</button>
									<span className="scenario3-intro-zoom-badge" title="Pulsa para ampliar">
										<MagnifyIcon size={18} />
									</span>
								</div>
							</div>
						</div>
						<div className="mt-1 d-flex align-items-center justify-content-end w-100">
						{/* Botón siguiente */}
						<NextButton
							navigateTo={ROUTES.SCENARIO3_CONTEXT2}
							activeScenario={activeScenario}
							color="violet"
							textColor="white"
						/>
						</div>
					</div>
				</div>
			</div>
			<ScenarioBar activeScenario={activeScenario} />

			{lightbox ? (
				<div
					className="scenario3-intro-lightbox-backdrop"
					role="dialog"
					aria-modal="true"
					aria-label="Vista ampliada"
					onMouseDown={(e) => {
						if (e.target === e.currentTarget) setLightbox(null);
					}}
				>
					<div className="scenario3-intro-lightbox-panel recuadro-white recuadro-border-violet position-relative p-2">
						<button
							type="button"
							className="scenario3-intro-lightbox-close"
							onClick={() => setLightbox(null)}
							aria-label="Cerrar"
						>
							<img src={closeCross} alt="" width={18} height={18} />
						</button>
						<img
							src={lightbox.src}
							alt={lightbox.alt}
							className="scenario3-intro-lightbox-img"
						/>
					</div>
				</div>
			) : null}
		</div>
	);
}

export default injectIntl(Scenario3Context1);
